<template>
  <ul class="form-item-list">
    <li><h3><b>[치아보험(특약) 가입시]</b> 최근 5년 이내에 치과 의사로부터 진찰 또는 검사를 통하여 다음과 같은 의료행위를 받은 사실이 있습니까?</h3></li>
    <li>
      <p>1. 치통</p>
      <p>2. 치아흔들림</p>
      <p>3. 치아우증)(충치)</p>
      <p>4. 치은염(잇몸염증)</p>
      <p>5. 치주질환(풍치,치주농양)</p>
      <p>6. 치수염(치아신경염증)</p>
      <p>7. 치아결손</p>
      <p>8. 치근단염</p>
      <p>9. 치아,치열교정</p>
      <p>10. 치경부마모증</p>
      <p>11. 임플란트</p>
      <p>12. 브릿지(보정성가공의치)</p>
      <p>13. 틀니(과철성의치)</p>
      <p>14. 치아파절</p>
    </li>
    <li class="text-center">
      <el-checkbox
        class="round"
        label="예"
        border
        v-model="yes"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'yes')"
      />
      <el-checkbox
        class="round"
        label="아니오"
        border
        v-model="no"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'no')"
      />
    </li>
  </ul>
</template>

<script>
import { Checkbox } from 'element-ui';

export default {
  name: 'Fetus',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      yes: this.formData.answer.value === '예',
      no: this.formData.answer.value === '아니오',
    }
  },
  methods: {
    updateChecked(event, type) {
      const reverse = type === 'yes' ? 'no' : 'yes';
      this.$data[reverse] = !event;
      this.$emit('update', { type: 'answer', value: type });
    },
  }
}
</script>

<style lang="scss" scoped>
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
}
</style>